/**
 * @author Fulin
 * @description 格式化时间
 * @param time
 * @param cFormat
 * @returns {string|null}
 */

import JSEncrypt from "jsencrypt";

export function setCookie(cookieName, cookieData) {
  // eslint-disable-next-line no-undef
  return Cookies.set(
    cookieName,
    cookieData /* , {
    domain: process.env.VUE_APP_ROOT_DOMAIN
  } */
  );
}

export function removeCookie(cookieName) {
  // eslint-disable-next-line no-undef
  Cookies.remove(
    cookieName /* , { domain: process.env.VUE_APP_ROOT_DOMAIN } */
  );
}

export function getCookie(cookieName) {
  // eslint-disable-next-line no-undef
  return Cookies.get(cookieName);
}

//获取token
export function getToken() {
  return getCookie(process.env.VUE_APP_TOKEN_NAME);
}

//settoken
export function setToken(tokenData) {
  return setCookie(process.env.VUE_APP_TOKEN_NAME, tokenData);
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

/**
 * @author Fulin
 * @description 格式化时间
 * @param time
 * @param option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

/**
 * @author Fulin
 * @description 将url请求参数转为json格式
 * @param url
 * @returns {{}|any}
 */
export function paramObj(url) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, " ") +
      '"}'
  );
}

/**
 * @author Fulin
 * @description 父子关系的数组转换成树形结构数据
 * @param data
 * @returns {*}
 */
export function translateDataToTree(data) {
  const parent = data.filter(
    value => value.parentId === "undefined" || value.parentId == null
  );
  const children = data.filter(
    value => value.parentId !== "undefined" && value.parentId != null
  );
  const translator = (parent, children) => {
    parent.forEach(parent => {
      children.forEach((current, index) => {
        if (current.parentId === parent.id) {
          const temp = JSON.parse(JSON.stringify(children));
          temp.splice(index, 1);
          translator([current], temp);
          typeof parent.children !== "undefined"
            ? parent.children.push(current)
            : (parent.children = [current]);
        }
      });
    });
  };
  translator(parent, children);
  return parent;
}

/**
 * @author Fulin
 * @description 树形结构数据转换成父子关系的数组
 * @param data
 * @returns {[]}
 */
export function translateTreeToData(data) {
  const result = [];
  data.forEach(item => {
    const loop = data => {
      result.push({
        id: data.id,
        name: data.name,
        parentId: data.parentId
      });
      const child = data.children;
      if (child) {
        for (let i = 0; i < child.length; i++) {
          loop(child[i]);
        }
      }
    };
    loop(item);
  });
  return result;
}

/**
 * @author Fulin
 * @description 10位时间戳转换
 * @param time
 * @returns {string}
 */
export function tenBitTimestamp(time) {
  const date = new Date(time * 1000);
  const y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? "" + m : m;
  let d = date.getDate();
  d = d < 10 ? "" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;
  return y + "年" + m + "月" + d + "日 " + h + ":" + minute + ":" + second; //组合
}

/**
 * @author Fulin
 * @description 13位时间戳转换
 * @param time
 * @returns {string}
 */
export function thirteenBitTimestamp(time) {
  const date = new Date(time / 1);
  const y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? "" + m : m;
  let d = date.getDate();
  d = d < 10 ? "" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;
  return y + "年" + m + "月" + d + "日 " + h + ":" + minute + ":" + second; //组合
}

/**
 * @author Fulin
 * @description 获取随机id
 * @param length
 * @returns {string}
 */
export function uuid(length = 32) {
  const num = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
  let str = "";
  for (let i = 0; i < length; i++) {
    str += num.charAt(Math.floor(Math.random() * num.length));
  }
  return str;
}

/**
 * @author Fulin
 * @description m到n的随机数
 * @param m
 * @param n
 * @returns {number}
 */
export function random(m, n) {
  return Math.floor(Math.random() * (m - n) + n);
}

/**
 * @author Fulin
 * @description addEventListener
 * @type {function(...[*]=)}
 */
export const on = (function() {
  return function(element, event, handler, useCapture = false) {
    if (element && event && handler) {
      element.addEventListener(event, handler, useCapture);
    }
  };
})();

/**
 * @author Fulin
 * @description removeEventListener
 * @type {function(...[*]=)}
 */
export const off = (function() {
  return function(element, event, handler, useCapture = false) {
    if (element && event) {
      element.removeEventListener(event, handler, useCapture);
    }
  };
})();

// 树转数组
export function treeToArray(tree, childrenKey, res) {
  res = res || [];
  for (let i = 0; i < tree.length; i++) {
    const item = {};
    for (const key in tree[i]) {
      if (Object.hasOwnProperty.call(tree[i], key)) {
        const element = tree[i][key];
        if (childrenKey !== key) {
          item[key] = element;
        }
      }
    }
    res.push(item);
    if (tree[i][childrenKey]) {
      treeToArray(tree[i][childrenKey], childrenKey, res);
    }
  }
  return res;
}

// 数组转tree
export function arrayToTree(list, idKey, parentKey, childrenKey) {
  let obj = {};
  for (let i = 0; i < list.length; i++) {
    obj[list[i][idKey]] = list[i];
  }
  const result = [];
  list.forEach(node => {
    if (!obj[node[parentKey]]) {
      result.push(node);
      return;
    }
    obj[node[parentKey]][childrenKey] = obj[node[parentKey]][childrenKey] || [];
    obj[node[parentKey]][childrenKey].push(node);
  });
  return result;
}

/**
 *
 * @param {*} list
 * @returns
 */
export function duplicateRemoval(list) {
  const obj = {};
  const newArr = [];
  list.forEach(item => {
    if (!obj[item.path]) {
      obj[item.path] = 1;
      newArr.push(item);
    }
  });
  return newArr;
}

/**
 * 时间格式转化
 */
export function fromDate(date) {
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var minute = date.getMinutes();
  minute = minute < 10 ? "0" + minute : minute;
  var second = date.getSeconds();
  second = second < 10 ? "0" + second : second;
  // + ' + h + ':' + minute + ':' + second
  return y + "-" + m + "-" + d;
}
export function deepClone(source) {
  if (!source || typeof source !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * get请求的时候，将参数拼接成字符串给后台
 */
export function RequestGet(data, isIn) {
  let str = "?";
  for (let key in data) {
    if (isIn && isIn[key]) {
      str += isIn[key] + "=" + data[key] + "&";
    } else {
      str += key + "=" + data[key] + "&";
    }
  }
  let getStr = str.slice(0, str.length - 1);
  return getStr;
}

/**
 * 整合数组转回来的参数装成对象
 */
export function reduceData(modelArr) {
  const data = modelArr.reduce((key, item) => {
    if (item.modelKey in key) {
      key[item.modelKey]++;
    } else {
      key[item.modelKey] = item.value;
    }
    return key;
  }, {});
  return data;
}

//获取当前日期函数
export function getNowFormatDate() {
  let date = new Date(),
    year = date.getFullYear(), //获取完整的年份(4位)
    month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
    strDate = date.getDate(); // 获取当前日(1-31)
  if (month < 10) month = `0${month}`; // 如果月份是个位数，在前面补0
  if (strDate < 10) strDate = `0${strDate}`; // 如果日是个位数，在前面补0

  return `${year}-${month}-${strDate}`;
}
// 下载流文件
export function downloadBlobFile(res, filename, fileType) {
  console.log(filename, "filename");
  console.log(fileType, "fileType");
  console.log(res, "res");
  let blob = new Blob([res]);
  if (fileType) {
    blob = new Blob([res], { type: fileType });
  }
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
// 数据字典遍历改格式方法
export function DictListData(data, type) {
  let list = data[type].map(item => {
    let obj = {
      label: item.dictItemName,
      value: item.dictItemCode
    };
    return obj;
  });
  return list;
}

/**
 *
 * @param {*} list 动态列的数据
 * @param {*} prop 拿来做prop的字段
 */
export function dynamicTable(list, prop) {
  let columns = []; // 生成 表头
  let data = []; // 生成表内容
  let foms = {};
  list.forEach(item => {
    let obj = {
      prop: item[prop],
      label: item.indexDesc,
      align: "center",
      type: "input",
      isCustom: true
    };
    columns.push(obj);
    foms = { [item[prop]]: item.indexValue };
  });
  data.push(foms);
  let tableComtent = {
    key: prop,
    columns: columns,
    data: data
  };
  return tableComtent;
}

// 当前时间格式化时分秒
export const getNowTime = () => {
  const time = new Date();
  let year = time.getFullYear();
  let month = time.getMonth() + 1;
  let day = time.getDate();
  let hour = time.getHours();
  let min = time.getMinutes();
  let sec = time.getSeconds();
  month = month < 10 ? `0${month}` : month;
  day = day < 10 ? `0${day}` : day;
  hour = hour < 10 ? `0${hour}` : hour;
  min = min < 10 ? `0${min}` : min;
  sec = sec < 10 ? `0${sec}` : sec;
  return `${year}-${month}-${day} ${hour}:${min}:${sec}`;
};

/**
 * 将正数设置成千分位
 * @param {*} value
 * @returns
 */
const setPercentile = value => {
  let newVal = value.toLocaleString();
  return newVal;
};

/**
 * 限制数字加两位小数加千分位转换
 * @param {*} val 要设置的数字
 */
export const numFun = (val, prop, decimalPlace) => {
  let temp = val ? val.toString() : "0";
  let burden = temp[0] === "-" ? temp[0] : "";
  if (!prop) {
    temp = temp.replace(/。/g, ".");
    temp = temp.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
    temp = temp.replace(/^\./g, ""); //验证第一个字符是数字
    temp = temp.replace(/\.{2,}/g, ""); //只保留第一个, 清除多余的
    temp = temp
      .replace(".", "$#$")
      .replace(/\./g, "")
      .replace("$#$", ".");
    if (decimalPlace) {
      temp = temp.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3"); //只能输入三个小数
    } else {
      temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
    }
  } else {
    temp = temp.replace(/[^\d{1,20}(\.\d)?$]/g, "");
  }
  let str = temp.split(".");
  let n1 = setPercentile(Number(str[0]));
  let n2 = str[1];
  let newTemp = n2 ? n1 + "." + n2 : n1;
  return burden + newTemp;
};

/**
 * 数字转千分位，保留指定小数位（默认2位），整数也补足小数位
 * @param {number|string} num 数字
 * @param {number} decimal 保留的小数位，默认2位
 * @returns {string} 79 -> '79.00'，77.1 -> '77.10'，12345.678 -> '12,345.68'
 */
export function thousandSeparator(num, decimal = 2) {
  if (num === null || num === undefined || num === "") return num;
  const value = Number(num);
  if (isNaN(value)) return num;
  const fixed = value.toFixed(decimal);
  const parts = fixed.split(".");
  const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return value == 0 ? 0 : parts.length > 1 ? intPart + "." + parts[1] : intPart;
}

export function customMd5(str) {
  const encryptor = new JSEncrypt();
  // 设置公钥
  const pubKey =
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAiVl1MeSaS/gncsjSTJIQJHLpuXj4AVCH3NTEb2WQjkFMDwQPNpMn3Wf0FDW4LkqXu9U7Flm+prF8bGZr2GoSZzTR6fQEM2Ce7DRm0xbWDNqj2I54+WqD1Tk/NfesTgno8rw2wdMnZ6x2rkLN1Vpmi5IV+xtHevKtLAIPFpdp1fW31/J8y/qgZAmvwuAK7XghG9VfYrWamKSPO3LGJ374jQmfiaa+6DuO4RqLuCldz04sl965g2lbulyShcVZzKPYBehF52XmsEgUkSvkox3C0tjJII03IsKsaRRCGB/jknbJT51ScQCYb4xdNP65yoB3FqS5GKTPwKrWYcXiDiKCBwIDAQAB"; // 公钥字符串
  encryptor.setPublicKey(pubKey);
  return encryptor.encrypt(str);
}
